<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 mb-12">
    <CentralHeader title="Meet The Partners"></CentralHeader>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-15 mt-10">
      <div
        v-for="(partner, idx) in partners"
        :key="idx"
        class="rounded-full  relative
                transform cursor-default "
      >
        <!-- <router-link :to="'/partner/' + partner._id"> -->
          <a>
            <img
              :src="imageForSpeaker(partner)"
              class="h-80 w-80 object-cover border-4 border-vectric rounded-full mx-auto"
              alt=""
            />
          </a>
        <!-- </router-link> -->
        <div class="flex justify-center">
          <div class="h-6 w-1.5 bg-vectric"></div>
        </div>
        <div class=" flex justify-center">
          <!--<router-link :to="'/partner/' + partner._id"> -->
            <!--<a
              class="bg-black text-white border-vectric border-4 font-semibold uppercase rounded-t-xl rounded-br-xl py-3 px-6 text-lg
          hover:bg-vectric hover:text-white"
            >-->
          <a
              class="bg-black text-white border-vectric border-4 font-semibold uppercase rounded-t-xl rounded-br-xl py-3 px-6 text-lg"
          >
              {{ partner.name }}
            </a>
          <!-- </router-link> -->
         </div>
       </div>
     </div>
   </div>
 </template>

 <script>
 import { sanityClient } from "../utils/sanity";
 import sanityImageBuilder from "../utils/sanityImageBuilder";
 import CentralHeader from "../components/shared/CentralHeader";

 export default {
   name: "Partners",
   components: { CentralHeader },
   data() {
     return {
       partners: []
     };
   },
   mounted() {
     this.fetchPartners();
   },
   methods: {
     fetchPartners() {
       const queryString = "*[_type == 'partner'] {...}";
       sanityClient
         .fetch(queryString)
         .then(res => {
           this.partners = res;
         })
         .catch(function(err) {
           console.log(err);
         });
     },
     imageForSpeaker(speaker) {
       return sanityImageBuilder
         .image(speaker.portrait)
         .width(500)
         .url();
     }
   }
 };
 </script>

 <style scoped>
 .speaker-box {
   background-color: #ffffff;
 }
 .speaker-img {
 }
 </style>
